import { render, staticRenderFns } from "./ExpirationModal.vue?vue&type=template&id=2d825157&scoped=true"
import script from "./ExpirationModal.vue?vue&type=script&lang=js"
export * from "./ExpirationModal.vue?vue&type=script&lang=js"
import style0 from "./ExpirationModal.vue?vue&type=style&index=0&id=2d825157&lang=less&scoped=true"
import style1 from "./ExpirationModal.vue?vue&type=style&index=1&id=2d825157&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d825157",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d825157')) {
      api.createRecord('2d825157', component.options)
    } else {
      api.reload('2d825157', component.options)
    }
    module.hot.accept("./ExpirationModal.vue?vue&type=template&id=2d825157&scoped=true", function () {
      api.rerender('2d825157', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ExpirationModal.vue"
export default component.exports